const BuildingInformation = ({ data }) => {
  return (
    <section className="block">
      <div className="fixed">
        <h2>Информация</h2>
        {data.description.split('\n').map((value, index) => (
          <p key={index}>{value}</p>
        ))}
      </div>
    </section>
  );
};

export default BuildingInformation;
